/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SignedUrl
 */
export interface SignedUrl {
    /**
     *
     * @type {string}
     * @memberof SignedUrl
     */
    url: string;
    /**
     *
     * @type {string}
     * @memberof SignedUrl
     */
    fileId: string;
}

/**
 * Check if a given object implements the SignedUrl interface.
 */
export function instanceOfSignedUrl(value: object): boolean {
    if (!('url' in value)) return false;
    if (!('fileId' in value)) return false;
    return true;
}

export function SignedUrlFromJSON(json: any): SignedUrl {
    return SignedUrlFromJSONTyped(json, false);
}

export function SignedUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignedUrl {
    if (json == null) {
        return json;
    }
    return {
        url: json['url'],
        fileId: json['file_id'],
    };
}

export function SignedUrlToJSON(value?: SignedUrl | null): any {
    if (value == null) {
        return value;
    }
    return {
        url: value['url'],
        file_id: value['fileId'],
    };
}
